module.exports = __webpack_public_path__ + "img/card.ca426305.png";